import { DodajSrodekModel } from "./dodajSrodekModel";

export class EdytujSrodekModel extends DodajSrodekModel {
    id: string;
}